"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRandomColorList = exports.getRandomColor = void 0;

var R = _interopRequireWildcard(require("ramda"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var colors = ['#5c6996', '#f4d138', '#6eac6e', '#8cdfa1', '#44ada3', '#3dcbc6', '#da5b69'];
/**
 *
 * @param {string[]} arr
 * @returns {typeof arr[number]}
 */

var random = function random(arr) {
  return arr[Math.floor(Math.random() * arr.length)];
};
/**
 *
 * @param {string} exclude
 * @returns {string}
 */


var getRandomColor = function getRandomColor(exclude) {
  return R.compose(random, R.without([exclude]))(colors);
};
/**
 *
 * @param {number} len
 * @returns {string[]}
 */


exports.getRandomColor = getRandomColor;

var getRandomColorList = function getRandomColorList(len) {
  if (!len) {
    return [];
  }

  var arr = Array(len).fill('');

  if (len > colors.length) {
    // remembering the last color so that they don't duplicate
    var color = '';
    return arr.map(function () {
      color = getRandomColor(color);
      return color;
    });
  } // picking a unique color for each element from list


  var colorsToUse = colors.slice();

  var _loop = function _loop(i) {
    arr[i] = colorsToUse[Math.floor(Math.random() * colorsToUse.length)];
    colorsToUse = colorsToUse.filter(function (c) {
      return c !== arr[i];
    });
  };

  for (var i = 0; i < len; i += 1) {
    _loop(i);
  }

  return arr;
};

exports.getRandomColorList = getRandomColorList;